import Seo from "@/components/Seo";
import { Reveal } from "@/components/motion";
import { useLang } from "@/i18n/LanguageContext";

const ChiSiamoPage = () => {
  const { t } = useLang();
  return (
    <div data-testid="chi-siamo-page">
      <Seo
        title={t("chi.seoTitle")}
        siteName="ROMACASA"
        description={t("chi.seoDesc")}
      />
      <section className="pt-40 sm:pt-48 pb-24 sm:pb-32">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Reveal className="flex justify-center mb-14">
            <img src="/icon-arch-dark.png" alt="ROMACASA" className="w-20 h-auto" data-testid="brand-icon" />
          </Reveal>
          <h1 className="sr-only">{t("chi.h1")}</h1>
          <div data-testid="manifesto-text">
            {[0, 1, 2, 3, 4, 5, 6].map((i) => (
              <Reveal key={i} delay={i * 0.06}>
                {i === 0 ? (
                  <p className="font-serif-d text-2xl sm:text-3xl lg:text-[2.1rem] font-medium leading-snug text-[#000000] mb-10 first-letter:text-[#000000] first-letter:text-7xl first-letter:float-left first-letter:leading-[0.85] first-letter:mr-3 first-letter:mt-1">
                    {t("chi.p0")}
                  </p>
                ) : (
                  <p className="text-[#2B323A] font-light text-base sm:text-lg leading-[1.9] mb-8">{t(`chi.p${i}`)}</p>
                )}
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1} className="mt-16 flex justify-center">
            <img src="/logo-dark.png" alt="ROMACASA Intermediazioni Immobiliari" className="h-12 w-auto opacity-90" data-testid="chi-siamo-logo" />
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default ChiSiamoPage;
